import React from "react";
import styled from "styled-components";
import Button from "@mui/material/Button";
import { Modal, Paper, Stack } from "@mui/material";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";

const OverviewButton = styled(Button)`
    font-size: 12px;
    z-index: 10;
    text-align: center;
    padding-right: 12px;
`;

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
};

const H = styled.h1`
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.secondary.main};
    margin: 0;
`;

const P = styled.p`
    font-size: 12px;
    font-weight: 300;
    max-width: 95%;
    color: ${({ theme }) => theme.palette.secondary.main};
    padding-bottom: 16px;
    margin: 0;
`;

const MaintainabilityButton = ({ codeQualityActivated }) => {
    if (codeQualityActivated) return null;
    const [open, setOpen] = React.useState(false);
    const [justRequested, setJustRequested] = React.useState(false);
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);

    if (justRequested)
        return (
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <AnalyticsIcon style={{ opacity: "0.8" }} />
                <p style={{ margin: 0, fontSize: "12px", fontWeight: 200 }}>
                    Your index is being calculated.
                </p>
            </Stack>
        );
    const handleRequest = async (would) => {
        try {
            let url = "/api/users/code-quality";
            if (would) {
                url += "?would=true";
            }
            await request(url, {
                method: "PUT",
            });
            setMessage(`Code maintainability index activated successfully`);
            setSeverity("success");
            setIsToastTriggered(true);
            setJustRequested(true);
        } catch (e) {
            setMessage(`Error occurred. Please try again.`);
            setSeverity("error");
            setIsToastTriggered(true);
            setJustRequested(false);
        }
    };

    return (
        <>
            <OverviewButton variant="contained" color="primary" onClick={() => setOpen(true)}>
                Activate maintainability index
            </OverviewButton>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Paper sx={style}>
                    <Stack direction="column" spacing={2}>
                        <H id="modal-modal-title" variant="h6" component="h2">
                            Activate maintainability index
                        </H>
                        <P id="modal-modal-description" sx={{ mt: 2 }}>
                            To calculate the maintainability index for your repositories we will
                            currently need to run a scan on your code. This is the only place we
                            access your code, and so we ask for your approval to activate this
                            functionality.
                        </P>
                        <Stack direction="column" spacing={2} alignItems="flex-end">
                            <Stack direction="row" justifyContent="flex-end" spacing={2}>
                                <Button
                                    color="secondary"
                                    size="medium"
                                    onClick={() => setOpen(false)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    size="medium"
                                    onClick={() => handleRequest()}
                                >
                                    That&apos;s fine!
                                </Button>
                            </Stack>
                            <Button
                                variant="text"
                                size="small"
                                color="secondary"
                                style={{ textTransform: "none", width: "330px", fontWeight: 300 }}
                                onClick={() => handleRequest(true)}
                            >
                                No thanks. I&apos;m more interested in an alternative.
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            </Modal>
        </>
    );
};
export default MaintainabilityButton;
